import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import './style.css'
import 'primeicons/primeicons.css'
import App from './App.vue'
import router from './router'
import { setupGlobalErrorHandler } from './utils/errorHandler'

const app = createApp(App)
const pinia = createPinia()

// Setup global error handling
setupGlobalErrorHandler(app)

app.use(pinia)
app.use(router)
app.use(PrimeVue, {
  theme: {
    preset: {
      semantic: {
        primary: {
          50: '#e8f5f0',
          100: '#d1ebe1',
          200: '#a3d7c3',
          300: '#75c3a5',
          400: '#4aa483',
          500: '#3d8a6d',
          600: '#307057',
          700: '#235641',
          800: '#163c2b',
          900: '#092215',
          950: '#041109'
        }
      }
    },
    options: {
      prefix: 'p',
      darkModeSelector: 'system',
      cssLayer: false
    }
  }
})
app.use(ToastService)

app.mount('#app')
